import { Outlet } from "react-router-dom";
import UserNavMenu from "components/layout/UserNavMenu";
import UpgradePlanOffCanvas from "components/layout/Offcanvas/UpgradePlanOffCanvas";
import { ReactNotifications } from "react-notifications-component";
import { useEffect } from "react";
import { useGlobalShortcuts } from "@/hooks/useGlobalShortcuts";

export default function AppLayout() {
  useGlobalShortcuts()

  useEffect(() => {
    import("./styles.scss");
    import("react-notifications-component/dist/theme.css");
    import("animate.css");
    import("@aws-amplify/ui-react/styles.css");
    import("filepond/dist/filepond.min.css");
    import("filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css");
    import("react-tippy/dist/tippy.css");
  }, []);

  return (
    <>
      <ReactNotifications />
      <UserNavMenu />
      <UpgradePlanOffCanvas />
      <div>
        <Outlet />
      </div>
    </>
  );
}